import { useSignOutFirebase } from '../firebase/useSignOutFirebase';
import { useCallback } from 'react';
import { graphql } from '@xolv-mybrightlink/common';

export const useSignOutMyBrightlink = (): (() => Promise<void>) => {
  const signOutFirebase = useSignOutFirebase();
  return useCallback(async () => {
    await signOutFirebase();
    await graphql.cache.reset();
    await graphql.resetStore();
  }, [signOutFirebase]);
};
